import {
	Button, Confirmation, connectedComponent, List, LoadingIndicator, SortableTable,
	Icon, DropDownOption, Modal, NpiComponent
} from 'gwx-voyager-components';
import moment from 'moment-timezone';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { parse, stringify } from 'query-string';
import React, { Component } from 'react';
import { createNPIComment, createSubscription, createSubscriptions, deleteNpiComment, updateNpiComment, validateAddress } from '../../Subscription/subscriptions.actions';
import TableAddress from '../../Util/TableAddress.react';
import fetchOpportunities from '../opportunities.action';
import { updateActivationStatus } from '../opportunities.action';
import '../opportunity-queue.scss';
import OpportunityQueueAddress from './OpportunityQueueAddress.react';


/**
 * A list of opportunities
 *
 * @class OpportunityList
 * @extends {Component}
 */
class OpportunityQueue extends Component {
	constructor(props) {
		super();
		this.discardConfirmation = this.discardConfirmation.bind(this);
		this.createSelected = this.createSelected.bind(this);
		this.manualCreate = this.manualCreate.bind(this);
		this.generateAddSelectedButton = this.generateAddSelectedButton.bind(this);
		this.updateGrid = this.updateGrid.bind(this);
		this.handleCheck = this.handleCheck.bind(this);
		this.onSelectDateRange = this.onSelectDateRange.bind(this);
		this.onClickCreate = this.onClickCreate.bind(this);
		this.toggleAll = this.toggleAll.bind(this);
		this.getDirectAddressHeader = this.getDirectAddressHeader.bind(this);
		this.onClickRefresh = this.onClickRefresh.bind(this);
		this.closeOptionsDropdown = this.closeOptionsDropdown.bind(this);
		this.confirmActivation = this.confirmActivation.bind(this);
		this.createConfirmationContent = this.createConfirmationContent.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.onClickStatusChange = this.onClickStatusChange.bind(this);
		this.handleMoreOptionsStyling=this.handleMoreOptionsStyling.bind(this);
		this.exportData = this.exportData.bind(this);
		this.handleMoreOptionsStyling = this.handleMoreOptionsStyling.bind(this);
		this.npiCommentCreate = this.npiCommentCreate.bind(this);
		this.npiCommentUpdate = this.npiCommentUpdate.bind(this);
		this.npiCommentDelete = this.npiCommentDelete.bind(this);
		let total = props.opportunities.filter((opp) => opp.directAddresses)
			.reduce((acc, opp) => (acc + opp.directAddresses.length), 0);
		total = props.opportunities.filter((opp) => opp.manualAddresses)
			.reduce((acc, opp) => (acc + opp.manualAddresses.length), total);
		// total = props.opportunities.filter((opp) => opp.nppesDirectAddresses)
		// 	.reduce((acc, opp) => (acc + opp.nppesDirectAddresses.length), total);

		this.state = {
			total,
			isFetching: props.isFetching || true,
			confirmation: null,
			buildDownloadUrl: null,
			openDropdowns: {},
			moreOptionsStyling: {},
			dateRangeDisplay: 'All Time',
			filter: {
				componentClass: 'input',
				filterButtonIcon: 'search',
				id: 'opportunity-filter',
				onChange: (value) => this.setState((prevState) => ({
					filter: { ...prevState.filter, value: value ? value.target && value.target.value : '' }
				})),
				onFilter: (value) => this.props.history.push(`?${stringify({
					...this.props.query,
					filterString: value
				})}`),
				placeholder: 'Search (Name, NPI, Sending Facility, Direct Address)',
				value: props.query.filterString
			},
			checked: props.checked || {},
			activationModal: null,
			showLoadingIndicator: true,
			opportunities: props.opportunities || []
		};
	}

	componentDidMount() {
		this.props.fetchOpportunities(this.props.communityId,
			this.props.startDate, this.props.endDate, this.props.addressFilter, this.props.query);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.opportunityCount >= nextProps.opportunities.length) {
			this.updateGrid(nextProps);
		}

		this.setState((prevState) => ({
			isFetching: nextProps.isFetching,
			filter: { ...prevState.filter, value: nextProps.query ? nextProps.query.filterString : '' }
		}));
	}

	shouldComponentUpdate(nextProps) {
		if (JSON.stringify(nextProps.query) !== JSON.stringify(this.props.query)) {
			this.props.fetchOpportunities(nextProps.communityId,
				nextProps.startDate, nextProps.endDate, nextProps.addressFilter, nextProps.query);
			return false;
		}
		return true;
	}

	handleRowClick(row) {
		this.confirmActivation(row);
	}

	confirmActivation(row) {
		this.setState({
			activationModal: <Modal
				title={(row.isActive || typeof row.isActive === 'undefined')
					? 'Inactivation Confirmation'
					: 'Activation Confirmation'
				}
				content={this.createConfirmationContent(row)}
				show
				onClose={() => this.onModalClose()}
				closeLabel='Cancel'
				buttons={[
					<Button
						id='direct-address-confirm'
						key='directAddressConfirm'
						className='btn-success'
						onClick={() => {
							this.onClickStatusChange(row); this.onModalClose();
						}}
					>
						Confirm
					</Button>]}
			/>
		});
	}

	onClickStatusChange(row) {
		const activationStatus = (typeof row.isActive === 'undefined' || row.isActive) ? 'inactivate' : 'activate';
		this.props.updateActivationStatus(row.providerNpi, this.props.communityId,
			this.props.startDate, this.props.endDate, this.props.addressFilter, activationStatus, this.props.query).then(() => {
				this.updateGrid(this.props);
			}
			);
	}

	onModalClose() {
		this.setState({
			activationModal: null
		});
	}

	createConfirmationContent(row) {
		return (
			<div className='text-justify'>
				{
					(row.isActive || typeof row.isActive === 'undefined')
						? <p>Are you sure you want to inactivate <b> NPI: {row.providerNpi} </b> for all facilities within this Community? You will not be able to build subscriptions for this NPI unless you Activate the NPI.</p>
						: <p>Are you sure you want to activate <b> NPI: {row.providerNpi} </b> for all facilities within this Community? </p>
				}
			</div>
		);
	}

	closeOptionsDropdown(cb) {
		this.setState({ openDropdowns: {} }, cb);
	}

	handleMoreOptionsStyling(row, e) {
		this.setState({
			moreOptionsStyling: {
				rowIndex: row.index,
				title: e.target.title
			}
		})
	}

	onClickRefresh(showLoadingIndicator = true) {
		if (showLoadingIndicator) {
			this.setState({ showLoadingIndicator: true });
		} else {
			this.setState({ showLoadingIndicator: false });
		}
		this.props.fetchOpportunities(this.props.communityId,
			this.props.startDate, this.props.endDate, this.props.addressFilter, this.props.query).then(() => {
				this.updateGrid(this.props);
				this.props.receiveOpportunityCount(this.props.opportunities.length);
			}
			);
	}

	/**
	 * Handles an input check.
	 *
	 * @param {Object} e - event object
	 * @param {String} providerAtsendingFacility - the id of the provider / sending facility in context
	 */
	handleCheck(e, providerAtSendingFacility, source) {
		if(source === 'nppesHpd'){
			const directAddress = e.target.value;
			const directAddresses = (this.state.checked[providerAtSendingFacility]
				&& this.state.checked[providerAtSendingFacility]?.['nppesHpd']?.slice(0)) || [];
			if (e.target.checked) {
				directAddresses.push(directAddress);
			} else if (directAddresses && directAddresses.length > 0) {
				const index = directAddresses.indexOf(directAddress);
				if (index > -1) {
					directAddresses.splice(directAddresses.indexOf(directAddress), 1);
				}
			}
			const checked = { ...this.state.checked, [providerAtSendingFacility]: { ...this.state.checked[providerAtSendingFacility], nppesHpd: directAddresses } };
			this.setState({ checked });
		} else if (source === 'hpd') {
			const directAddress = e.target.value;
			const directAddresses = (this.state.checked[providerAtSendingFacility]
				&& this.state.checked[providerAtSendingFacility]?.['hpd']?.slice(0)) || [];
			if (e.target.checked) {
				directAddresses.push(directAddress);
			} else if (directAddresses && directAddresses.length > 0) {
				const index = directAddresses.indexOf(directAddress);
				if (index > -1) {
					directAddresses.splice(directAddresses.indexOf(directAddress), 1);
				}
			}
			const checked = { ...this.state.checked, [providerAtSendingFacility]: { ...this.state.checked[providerAtSendingFacility], hpd: directAddresses } };
			this.setState({ checked });
		} else if (source === 'manual') {
			const directAddress = e.target.value;
			const directAddresses = (this.state.checked[providerAtSendingFacility]
				&& this.state.checked[providerAtSendingFacility]?.['manual']?.slice(0)) || [];
			if (e.target.checked) {
				directAddresses.push(directAddress);
			} else if (directAddresses && directAddresses.length > 0) {
				const index = directAddresses.indexOf(directAddress);
				if (index > -1) {
					directAddresses.splice(directAddresses.indexOf(directAddress), 1);
				}
			}
			const checked = { ...this.state.checked, [providerAtSendingFacility]: { ...this.state.checked[providerAtSendingFacility], manual: directAddresses } };
			this.setState({ checked });
		}else {
			const directAddress = e.target.value;
			const directAddresses = (this.state.checked[providerAtSendingFacility]
				&& this.state.checked[providerAtSendingFacility]?.['nppes']?.slice(0)) || [];
			if (e.target.checked) {
				directAddresses.push(directAddress);
			} else if (directAddresses && directAddresses.length > 0) {
				const index = directAddresses.indexOf(directAddress);
				if (index > -1) {
					directAddresses.splice(directAddresses.indexOf(directAddress), 1);
				}
			}
			const checked = { ...this.state.checked, [providerAtSendingFacility]: { ...this.state.checked[providerAtSendingFacility], nppes: directAddresses } };
			this.setState({ checked });
		}
	}

	/**
	 * Handles an update to the date range
	 *
	 * @param {String} range
	 */
	onSelectDateRange(range) {
		let startDate = null;
		let endDate = null;
		if (range === '7 Days') {
			startDate = moment().utc().subtract(7, 'days').startOf('day')
				.valueOf();
			endDate = moment().utc().endOf('day').valueOf();
		} else if (range === '30 Days') {
			startDate = moment().utc().subtract(30, 'days').startOf('day')
				.valueOf();
			endDate = moment().utc().endOf('day').valueOf();
		}
		const dateRangeDisplay = range;
		this.setState({ dateRangeDisplay }, () => this.props.history.push(`?${stringify({
			...this.props.query,
			startDate,
			endDate
		})}`));
	}

	onClickCreate(id, response, successCallback) {
		if (id) {
			this.updateGrid({
				...this.props,
				opportunities: this.state.opportunities.filter((o) => o.providerAtSendingFacility !== id)
			});
		}
		if (successCallback) {
			successCallback(response);
		}
	}

	getDirectAddressHeader() {
		const checkedKeys = Object.keys(this.state.checked || {});
		return this.state.total > 0 ? (
			<label htmlFor='option-select-all'>
				<input
					className='mr-2'
					name='select-all'
					type='checkbox'
					value='select-all'
					onChange={(val) => this.toggleAll(val)}
					checked={checkedKeys
						&& checkedKeys.length > 0
						&& checkedKeys.map(c => [].concat(...Object.values(this.state.checked[c]))).reduce((acc, curr) => acc.concat(...curr), []).length
						=== this.state.total}
				/>
				Direct Addresses
			</label>
		) : 'Direct Addresses';
	}

	updateGrid(props, checked = this.state.checked || {}, cb) {
		let total = props.opportunities.filter((opp) => opp.directAddresses)
			.reduce((acc, opp) => (acc + opp.directAddresses.length), 0);
		total = props.opportunities.filter((opp) => opp.manualAddresses)
			.reduce((acc, opp) => (acc + opp.manualAddresses.length), total);
		total = props.opportunities.filter((opp) => opp.nppesDirectAddresses)
			.reduce((acc, opp) => (acc + opp.nppesDirectAddresses.length), total);
		total = props.opportunities.filter((opp) => opp.hpdNppesDirectAddresses)
			.reduce((acc, opp) => (acc + opp.hpdNppesDirectAddresses.length), total);
		this.setState({
			total,
			checked: total ? checked : [],
			opportunities: props.opportunities
		});
		if (cb) {
			cb();
		}
	}

	manualCreate(subscription, successCallback, errorCallback, opportunityCount) {
		this.props.create(subscription, successCallback, errorCallback, opportunityCount).then(() => this.updateGrid({
			...this.props,
			opportunities: this.state.opportunities.filter((o) => o.providerAtSendingFacility !== subscription.providerAtSendingFacility)
		},
			{}, this.onClickRefresh(false)));
	}

	/**
	 * Creates subscriptions for all selected opportunities.
	 * Prompts user to confirm.
	 */
	createSelected() {
		const confirmationProps = {
			body: 'Are you sure you want to add subscriptions for selected opportunities?',
			id: 'bulk-create-confirmation',
			onClickCancel: this.discardConfirmation,
			onClickConfirm: () => this.props.bulkCreate(this.state.opportunities.filter((o) => 
				(o.hpdNppesDirectAddresses && o.hpdNppesDirectAddresses.some((d) => this.state.checked[o.providerAtSendingFacility] && this.state.checked[o.providerAtSendingFacility]?.['nppesHpd']?.includes(d))) ||
				(o.directAddresses && o.directAddresses.some((d) => this.state.checked[o.providerAtSendingFacility] && (this.state.checked[o.providerAtSendingFacility]?.['hpd']?.includes(d) || this.state.checked[o.providerAtSendingFacility]?.['manual']?.includes(d)))) ||
				(o.nppesDirectAddresses && o.nppesDirectAddresses.some((e) => this.state.checked[o.providerAtSendingFacility] && this.state.checked[o.providerAtSendingFacility]?.['nppes']?.includes(e))))
				.map((p) => ({
						...p,
						directAddresses: p.directAddresses ? p.directAddresses.filter((x) => this.state.checked[p.providerAtSendingFacility]?.['hpd']?.includes(x)) : null,
						manualAddressesLst: p.directAddresses ? p.directAddresses.filter((a) => this.state.checked[p.providerAtSendingFacility]?.['manual']?.includes(a)) : null,
						nppesDirectAddresses: p.nppesDirectAddresses ? p.nppesDirectAddresses.filter((y) => this.state.checked[p.providerAtSendingFacility]?.['nppes']?.includes(y)) : null,
						hpdNppesDirectAddresses: p.hpdNppesDirectAddresses ? p.hpdNppesDirectAddresses.filter((z) => this.state.checked[p.providerAtSendingFacility]?.['nppesHpd']?.includes(z)) : null,
					})),
				this.props.opportunityCount).then(this.discardConfirmation)
				.then(() => this.updateGrid({

					...this.props,
					opportunities:
						this.state.opportunities
							.filter((o) => !o.directAddresses || !o.directAddresses
								.some((d) => this.state.checked[o.providerAtSendingFacility]
									&& this.state.checked[o.providerAtSendingFacility]?.['hpd']?.includes(d)))
				},
					{})),
			target: this.confirmationTarget,
			title: `Confirm Adding ${Object.keys(this.state.checked).map(c => [].concat(...Object.values(this.state.checked[c]))).reduce((acc, curr) => acc.concat(...curr), []).length} Subscriptions`,
			placement: 'left'
		};
		this.setState((prevState) => ({
			confirmation: <Confirmation {...confirmationProps} />
		}));
	}

	/**
	 * Removes the Delete Confirmation.
	 */
	discardConfirmation() {
		this.setState({ confirmation: null });
	}

	generateAddSelectedButton() {
		const checkedKeys = Object.keys(this.state.checked || {});
		if (checkedKeys
			&& checkedKeys.length > 0
			&& checkedKeys.map(c => [].concat(...Object.values(this.state.checked[c]))).reduce((acc, curr) => acc.concat(...curr), []).length > 0) {
			return (
				<Button
					id='bulk-create-selected'
					className='btn btn-success pull-right mb-4'
					onClick={this.createSelected}
					// eslint-disable-next-line no-return-assign
					refCallback={(button) => (this.confirmationTarget = button)}
				>
					{`Add Selected (${checkedKeys.map(c => [].concat(...Object.values(this.state.checked[c]))).reduce((acc, curr) => acc.concat(...curr), []).length})`}
				</Button>
			);
		}
		return null;
	}

	toggleAll(val) {
		let checked = {};
		if (val.target.checked) {
			checked = this.state.opportunities.filter((o) => o.directAddresses || o.nppesDirectAddresses || o.hpdNppesDirectAddresses).reduce((map, s) => {
				const checkMap = map;
				checkMap[s.providerAtSendingFacility] = {
					...(s.directAddresses && { hpd: s.directAddresses }),
					...(s.nppesDirectAddresses && { nppes: s.nppesDirectAddresses }),
					...(s.hpdNppesDirectAddresses && { nppesHpd: s.hpdNppesDirectAddresses }),
				}
				console.log(checkMap);
				return checkMap;
			}, {});
		}
		this.setState({ checked });
	}

	exportData() {
		this.setState({
			buildDownloadUrl:
				`/api/opportunities/export?${stringify({
					...this.props.query,
					communityId: this.props.communityId,
					startDate: this.props.startDate,
					addressFilter: this.props.addressFilter,
					endDate: moment().utc().valueOf()
				})}`
		});
	}

	npiCommentCreate(npiCommentObject) {
		this.props.createNPIComment(npiCommentObject, this.onClickRefresh);
	}

	npiCommentUpdate(npiCommentId, npiCommentObject) {
		this.props.updateNpiComment(npiCommentId, npiCommentObject, this.onClickRefresh);
	}

	npiCommentDelete(npiCommentId) {
		this.props.deleteNpiComment(npiCommentId, this.onClickRefresh)
	}

	render() {
		const listProps = {
			action: {
				id: 'export-data-button',
				title: 'Export Data',
				onClick: this.exportData,
				className: 'btn btn-outline-primary my-2 my-sm-0',
				iconName: 'file-excel-o',
				disabled: this.props.opportunities.length===0,
			},
			gridClass: 'd-none',
			rows: [],
			isFetching: false,
			filter: this.state.filter,
			create: {
				id: 'create-subscrition',
				title: 'Create Subscription',
				onClick: this.props.onCreate
			},
			refresh: {
				id: 'refresh-build-button',
				title: 'Refresh Build',
				onClick: this.onClickRefresh
			},
			updateQueryParam: (key, value) => this.props.history.push(`?${stringify({
				...this.props.query,
				[key]: value.toLowerCase().replace(' ', '')
			})}`),
			navDropDowns: [{
				display: this.state.dateRangeDisplay,
				id: 'dateRange',
				title: 'Date Range',
				options: [{
					id: 'dateRange',
					value: 'All Time',
					onClick: (id, value) => this.onSelectDateRange(value)
				},
				{
					id: 'dateRange',
					value: '7 Days',
					onClick: (id, value) => this.onSelectDateRange(value)
				},
				{
					id: 'dateRange',
					value: '30 Days',
					onClick: (id, value) => this.onSelectDateRange(value)
				}]
			}, {
				display: this.props.addressFilterDisplay,
				id: 'addressFilter',
				title: 'Address Filter',
				options: this.props.addressFilterOptions.map((value) => ({ id: 'addressFilter', value }))
			}]
		};

		const rows = this.props.opportunities.map((curr) => {
			let displayName;
			const npiIconDisplay = {
				iconName: 'user-md',
				tooltip: 'Individual',
				iconStyle: 'fa-lg'
			};


			if (curr.nppesDemographic.enumeration_type === 'NPI-2') {
				displayName = curr.nppesDemographic.organizationName;
				npiIconDisplay.tooltip = 'Organization';
				npiIconDisplay.iconName = 'building';
			} else {
				displayName = `${curr.nppesDemographic.lastName}, ${curr.nppesDemographic.firstName}`;
			}

			const npiProps = {
				providerNpi: curr.providerNpi,
				npiIconDisplay: { ...npiIconDisplay },
				href: curr.providerNpiRegistryUrl,
				linkAttributes: { target: 'blank' }
			};
			

			const npiCommentProps = {
				npiCommentId: (typeof curr.npiComment === 'undefined' || !curr.npiComment.id) ? '' : curr.npiComment.id || '',
				npiComment: (typeof curr.npiComment === 'undefined' || !curr.npiComment.npiComment) ? '' : curr.npiComment.npiComment || '',
				communityId: this.props.communityId,
				npi: curr.providerNpi,
				invalidNpi: (typeof curr.providerNpi === 'undefined' || curr.providerNpi) ? false : true,
				npiCommentCreate: this.npiCommentCreate,
				npiCommentUpdate: this.npiCommentUpdate,
				npiCommentDelete: this.npiCommentDelete
			}

			const options = (typeof curr.isActive === 'undefined' || curr.isActive) ? 'Inactivate' : 'Activate';
			return {
				name: displayName,
				npi: npiProps,
				sendingFacility: curr.sendingFacilityDisplayName,
				address: <TableAddress {...curr.nppesDemographic} key={curr.primaryCareProviderNpi} />,
				count: curr.count.toString(),
				directAddresses: (typeof curr.isActive === 'undefined' || curr.isActive)
					? <OpportunityQueueAddress
						{...curr}
						create={
							(payload, successCallback, errorCallback) => this.manualCreate(payload,
								() => this.onClickCreate(curr.id, curr.providerAtSendingFacility, successCallback),
								errorCallback,
								this.props.opportunityCount)
						}
						validateAddress={
							(payload, successCallback, errorCallback) => this.props.validateAddress(payload,
								(response) => this.onClickCreate(curr.id, response, successCallback),
								errorCallback,
								this.props.opportunityCount)
						}
						id={curr.providerAtSendingFacility}
						checked={this.state.checked || {}}
						handleCheck={this.handleCheck}
					/>
					: <div className='tooltip-hd'>--
						<span className='tooltip-hd-text tooltip-hd-right'>Activate to add addresses</span>
					</div>,
				moreOptions: (
					<div
						className={classnames('dropdown', {
							show: !!this.state.openDropdowns[curr.providerAtSendingFacility]
						})}
						id={`${curr.providerAtSendingFacility}-options-dropdown`}
					>
						<Button
							className='btn-link'
							data-toggle='dropdown'
							aria-haspopup='true'
							aria-expanded='false'
							id={`${curr.providerAtSendingFacility}-options-btn`}
							onClick={() => this.setState((prevState) => ({
								openDropdowns: {
									[curr.providerAtSendingFacility]: !prevState.openDropdowns[curr.providerAtSendingFacility]
								}
							}))}
							show={this.state.openDropdowns[curr.providerAtSendingFacility]}
							title='More Options'
							type='button'
						>
							<Icon iconName='ellipsis-h' iconStyle='fa-lg' tooltip='More Options' />
						</Button>
						<div
							className='dropdown-menu dropdown-menu-right'
							aria-labelledby={`${curr.providerAtSendingFacility}-options-btn`}
						>
							<DropDownOption
								value={options}
								onClick={() => this.closeOptionsDropdown(
									() => this.handleRowClick(curr)
								)}
							/>
						</div>
					</div>
				),
				npiComments: (
					<NpiComponent npis={npiProps} npiComments={npiCommentProps} />
				),
			};
		});

		const headers = [
			{
				Header: 'Name',
				accessor: 'name'
			},
			{
				Header: "NPI",
				accessor: "npiComments",
				sortType : customNpiSort,
				id: "npi",
			},
			{
				Header: 'Sending Facility',
				accessor: 'sendingFacility'
			},
			{
				Header: 'Address',
				accessor: 'address',
				disableSortBy: true
			},
			{
				Header: 'Count',
				accessor: 'count'
			},
			{
				Header: this.getDirectAddressHeader(),
				accessor: 'directAddresses',
				disableSortBy: true
			},
			{
				Header: '',
				accessor: 'moreOptions',
				disableSortBy: true
			}
		];

		function customNpiSort(rowA,rowB,id,desc){
			let a = Number(rowA.values[id].props.npis.providerNpi);
			let b = Number(rowB.values[id].props.npis.providerNpi);
			if(Number.isNaN(a)){
				a= desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
			} 
			if(Number.isNaN(b)){
				b = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
			} 
			return a > b ? 1:-1;
		}

		const initialState = {
			sortBy: [
				{
					id: 'count',
					desc: true
				}
			]
		};

		const gridProps = {
			columns: headers,
			className: 'event-list',
			data: rows,
			disableMultiSort: true,
			disableSortRemove: true,
			disableMultiRemove: true,
			initialState,
			onRowClicked: (row, e) => this.handleMoreOptionsStyling(row, e),
			moreOptionsStyling: this.state.moreOptionsStyling
		};

		return (
			<div className='opportunity-list'>
				<List {...listProps} />
				{this.props.isFetching && this.state.showLoadingIndicator ? <LoadingIndicator /> : <SortableTable {...gridProps} />}
				{
					gridProps.data.length === 0 && !this.state.isFetching
						? (
							<div className='well well-lg text-center'>
								<h3>No Results Found</h3>
							</div>
						) : null
				}
				{this.generateAddSelectedButton()}
				{this.state.confirmation}
				{this.state.activationModal}
				<iframe
					title='Build Download iFrame'
					name='build-download-iframe'
					id='build-download-iframe'
					style={{ display: 'none' }}
					src={this.state.buildDownloadUrl}
				/>
			</div>
		);
	}
}
OpportunityQueue.defaultProps = {
	opportunities: [],
	checked: {}
};
OpportunityQueue.propTypes = {
	/**
	 * Whether opportunity data is being fetched
	 */
	isFetching: PropTypes.bool.isRequired,
	/**
	 * Opportunity data
	 */
	opportunities: PropTypes.arrayOf(PropTypes.object),
	/**
	 * Function that fetches opportunities
	 */
	fetchOpportunities: PropTypes.func.isRequired,
	/**
	 * Community Identifier
	 */
	communityId: PropTypes.string.isRequired,
	/**
	 * Date range start epoch
	 */
	startDate: PropTypes.string.isRequired,
	/**
	 * Date range end epoch
	 */
	endDate: PropTypes.string.isRequired,
	/**
	 * How direct addresses are filtered.
	 */
	addressFilter: PropTypes.string.isRequired,
	/**
	 * The display for the addressFilter dropdown.
	 */
	addressFilterDisplay: PropTypes.string.isRequired,
	/**
	 * The list of options that will populate the addressFilter dropdown.
	 */
	addressFilterOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
	/**
	 * A function to create subscriptions
	 */
	bulkCreate: PropTypes.func.isRequired,
	/**
	 * A function to receive opportunity count
	 */
	receiveOpportunityCount: PropTypes.func.isRequired,
	/**
	 * A function to update activation status
	 */
	updateActivationStatus: PropTypes.func.isRequired,

	onCreate: PropTypes.func.isRequired,
	/**
	 * Current browser history
	 */
	history: PropTypes.shape({
		push: PropTypes.func
	}).isRequired,
	/**
	 * The sidebar count of opportunities in the queue
	 */
	opportunityCount: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,

	checked: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object
	])
};

const mapStateToProps = (state, props) => {
	const {
		opportunityCount,
		entities: { opportunities }
	} = state;
	const {
		match: { params: { id: communityId } },
		location
	} = props;
	const query = parse(location.search);
	const addressFilterOptions = [{
		display: 'Active',
		value: 'active'
	}, {
		display: 'Email',
		value: 'email'
	}, {
		display: 'No Email',
		value: 'noemail'
	},
	{
		display: 'Inactive',
		value: 'inactive'
	}];
	const found = addressFilterOptions.find((o) => o.value === query.addressFilter);
	return {
		isFetching: opportunities.isFetching,
		opportunities: opportunities.ids.map((id) => opportunities.results[id]),
		communityId,
		startDate: query && query.startDate ? query.startDate : '1',
		endDate: query && query.endDate ? query.endDate : moment().utc().endOf('day').valueOf()
			.toString(),
		addressFilter: found ? found.value : addressFilterOptions[0].value,
		addressFilterDisplay: found ? found.display : addressFilterOptions[0].display,
		addressFilterOptions: addressFilterOptions.map((o) => o.display),
		opportunityCount,
		query
	};
};

const mapDispatchToProps = (dispatch, props) => ({
	/**
	 * Dispatches an action to delete the NPI Comment.
	 *
	 * @param {String} id - npi comment id
	 *
	 */
	deleteNpiComment: (npiCommentId, successCallback, errorCallback) => (dispatch(
		deleteNpiComment(npiCommentId)
	).then((response) => {
		if (response.error) {
			if (errorCallback) {
				errorCallback(response.error.message);
			}
			return;
		}

		if (successCallback) {
			setTimeout(() => successCallback(), 1000);
		}
		dispatch({
			type: 'TRIGGER_ALERT',
			alert: {
				type: 'success',
				dismissable: true,
				message: 'NPI Comment successfully Deleted',
				duration: 3000
			}
		});
	})
	),

	/**
	 * Dispatches an action to update the NPI Comment.
	 *
	 * @param {String} id - npi comment id
	 * @param {Object} npiCommentObject - Object that contains updated comment for NPI
	 *
	 */
	updateNpiComment: (npiCommentId, npiCommentObject, successCallback, errorCallback) => (dispatch(
		updateNpiComment(npiCommentId, npiCommentObject)
	).then((response) => {
		if (response.error) {
			if (errorCallback) {
				errorCallback(response.error.message);
			}
			return;
		}

		if (successCallback) {
			setTimeout(() => successCallback(), 1000);
		}
		dispatch({
			type: 'TRIGGER_ALERT',
			alert: {
				type: 'success',
				dismissable: true,
				message: 'NPI Comment successfully updated',
				duration: 3000
			}
		});
	})

	),

	/**
	 * Creates a NPI Comment.  Triggers an alert based on the
	 * response of creating the NPI Comment.
	 *
	 * @param {Object} npiCommentObject - the NPI Comment to create for NPI at community level.
	 */
	createNPIComment: (npiCommentObject, successCallback, errorCallback) => (dispatch(
		createNPIComment(npiCommentObject)
	).then((response) => {
		if (response.error) {
			if (errorCallback) {
				errorCallback(response.error.message);
			}
			return;
		}

		if (successCallback) {
			setTimeout(() => successCallback(), 1000);
		}
		dispatch({
			type: 'TRIGGER_ALERT',
			alert: {
				type: 'success',
				dismissable: true,
				message: 'NPI Comment successfully created',
				duration: 3000
			}
		});
	})),

	/**
	 * Dispatches an action to fetch opportunities.
	 *
	 * @param {String} communityId
	 * @param {String} start - start date epoch
	 * @param {String} end - end date epoch
	 * @param {String} addressFilter - how the directAddresses should be filtered
	 * @param {object} query - additional query parameters
	 */
	fetchOpportunities: (communityId, start, end, addressFilter, query) => (dispatch(
		fetchOpportunities(communityId, start, end, addressFilter, query)
	).then((response) => {
		const exception = response.error;
		if (undefined !== exception && exception.status === 507) {
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'danger',
					dismissable: true,
					children: exception.message,
					html: true
				}
			});
		}
	})),

	onCreate: () => props.history.push(`/${props.match.params.id}/opportunities/add${props.location.search}`),


	/**
	 * Dispatches an action to update the activation status and fetch opportunities.
	 *
	 * @param {String} npi
	 * @param {String} communityId
	 * @param {String} start - start date epoch
	 * @param {String} end - end date epoch
	 * @param {String} addressFilter - how the directAddresses should be filtered
	 * @param {object} activationStatus - activation status
	 */
	updateActivationStatus: (npi, communityId, start, end, addressFilter, activationStatus, query) => (dispatch(
		updateActivationStatus(npi, communityId, start, end, addressFilter, activationStatus, query)
	).then((response) => {
		const exception = response.error;
		if (undefined !== exception && exception.status === 507) {
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'danger',
					dismissable: true,
					children: exception.message,
					html: true
				}
			});
		}
		dispatch({
			type: 'TRIGGER_ALERT',
			alert: {
				type: 'success',
				dismissable: true,
				message: 'Provider subscription status was successfully updated.',
				duration: 5000
			}
		});
	})),

	/**
	 * Creates a single subscription.  Triggers an alert based on the
	 * response of creating the subscription.
	 *
	 * @param {Object} subscription - the subscription to create.
	 */
	create: (subscription, successCallback, errorCallback, opportunityCount) => (dispatch(
		createSubscription(subscription)
	)
		.then((response) => {
			if (response.error) {
				if (errorCallback) {
					errorCallback(response.error.message);
				}
				return;
			}

			if (successCallback) {
				successCallback();
			}
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: 'Subscription successfully created',
					duration: 5000
				}
			});
			dispatch({
				type: 'RECEIVE_OPPORTUNITY_COUNT',
				count: opportunityCount - 1
			});
		})),
	/**
	 * Bulk create an array of subscriptions.  An alert is triggered
	 * based on the response of creating the subscriptions.
	 *
	 * @param {Array} subscriptions - array of subscription objects.
	 */
	bulkCreate: (subscriptions, opportunityCount) => (dispatch(createSubscriptions(subscriptions))
		.then((response) => {
			const exceptions = response
				.filter((r) => (r.error));
			if (exceptions.length > 0) {
				dispatch({
					type: 'TRIGGER_ALERT',
					alert: {
						type: 'danger',
						dismissable: true,
						message: exceptions.reduce((acc, r) => (`${acc}${r.error.message}`), 'Exceptions: ')
					}
				});

				return;
			}
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: 'Subscriptions successfully created',
					duration: 5000
				}
			});
			dispatch({
				type: 'RECEIVE_OPPORTUNITY_COUNT',
				count: opportunityCount - (subscriptions.length)
			});
		})),

	/**
	 * Verifys if the direct address is trusted.
	 *
	 * @param {Object} directAddress - the direct address to verify the trust.
	 */
	validateAddress: (directAddress, successCallback, errorCallback) => (dispatch(
		validateAddress(directAddress)
	)
		.then((response) => {
			if (response.error) {
				if (errorCallback) {
					errorCallback(response.error.fields.email);
				}
				return;
			}

			if (successCallback) {
				successCallback(response);
			}
		})),

	receiveOpportunityCount: (opportunityCount) => (dispatch({
		type: 'RECEIVE_OPPORTUNITY_COUNT',
		count: opportunityCount
	}))
});

const OpportunityListContainer = connectedComponent(OpportunityQueue, mapStateToProps, mapDispatchToProps);

export { OpportunityListContainer as default, OpportunityQueue, mapStateToProps };